const React = require("react");
const { AdminInventorySourceResource } = require("../components/AdminInventorySourceResource");
const h = React.createElement;
const AdminInventorySourceProducts = () => h(AdminInventorySourceResource, { title: "InventorySource products", loader: "getAdminProducts", collection: "products", columns: [{ key: "title", label: "Product" }, { key: "brand", label: "Brand" }, { key: "stockQuantity", label: "Stock" }, { key: "status", label: "Status" }] });
module.exports = { AdminInventorySourceProducts };
